// Mobile users landing on POS entry routes ('/' or '/login') get redirected
// to the owner mobile flow. Runs after bootstrap-guard plugin (which already
// allows the /v2-owner-report-mobile prefix).
//
// Override via query: ?force=desktop or ?force=owner

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  if (to.path.startsWith('/v2-owner-report-mobile')) return

  const isEntry = to.path === '/' || to.path === '/login'
  if (!isEntry) return

  if (to.query.force === 'desktop') return
  if (to.query.force === 'owner') return navigateTo('/v2-owner-report-mobile')

  const { isMobile } = useDevice()
  if (isMobile) return navigateTo('/v2-owner-report-mobile')
})
